import { Button } from "@tellescope/design-system";
import {
  FilterBlockEditor,
  MultiSelect,
  type MultiSelectOption,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@tellescope/ui";
import { type FreeformFieldOption, type FreeformFilterBlock } from "@tellescope/utils";
import { ListFilter } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface TagsFilterPopoverProps {
  filterBlock: FreeformFilterBlock;
  fieldOptions: FreeformFieldOption[];
  selectOptions: MultiSelectOption[];
  onFilterChange: (block: FreeformFilterBlock) => void;
}

export const TagsFilterPopover = ({
  filterBlock,
  fieldOptions,
  selectOptions,
  onFilterChange,
}: TagsFilterPopoverProps) => {
  const { t } = useTranslation("contacts");

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button iconOnly variant="ghost" size="sm" color="muted" hoverLabel={t("Filter tags")}>
          <ListFilter />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-2" align="end">
        <FilterBlockEditor
          block={filterBlock}
          fieldOptions={fieldOptions}
          onChange={onFilterChange}
          onRemove={() => onFilterChange({ ...filterBlock, filters: [] })}
          renderValueInput={({ filter, onChange }) => (
            <MultiSelect
              className="w-full bg-white text-xs font-light"
              options={selectOptions}
              value={Array.isArray(filter.value) ? filter.value : []}
              onValueChange={(value) => onChange({ ...filter, value })}
              placeholder={t("Select tags")}
              creator={{
                render: (input) => t('Add "{{tag}}"', { tag: input }),
                transform: (input) => input,
                onCreate: () => {},
              }}
            />
          )}
        />
      </PopoverContent>
    </Popover>
  );
};
